<template>
    <textarea
        :id="id ?? null"
        ref="textarea"
        class="input input-editor"
        :name="name"
        :placeholder="placeholder">{{ inputValue }}</textarea>
</template>

<script>
var CKEDITOR_BASEPATH = '/js/admin/ckeditor/';

export default {
    props: [
        'modelValue',
        'label',
        'name',
        'type',
        'value',
        'placeholder',
        'id',
    ],
    data() {
        return {}
    },
    computed: {
        inputValue() {
            return this.modelValue ?? this.value;
        }
    },
    mounted() {
        let inst = CKEDITOR.replace(this.$refs.textarea, {
            config: '/js/admin/ckeditor/config.js?t=' + Math.random(0, 32).toString(),
        });
        inst.on('change', () => {
            this.$emit('update:modelValue', inst.getData());
        });
    },
    methods: {}
}
</script>
